import { render, staticRenderFns } from "./TeacherDetail.vue?vue&type=template&id=5186f9ac"
import script from "./TeacherDetail.vue?vue&type=script&lang=js"
export * from "./TeacherDetail.vue?vue&type=script&lang=js"
import style0 from "./TeacherDetail.vue?vue&type=style&index=0&id=5186f9ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports